'use strict';

var _ = require('lodash');
var UserPreferencesService = function UserPreferencesService($state, userSecureService, MomentConstants, configurationService) {
  function getUserSettingComponent(component, fromWorkflow) {
    var User = userSecureService.getCurrentUser();
    var CURRENT_SCREEN = fromWorkflow || _.camelCase(_.get($state, 'current.name', '').replace('app.', ''));
    var USER_SCREEN_PREFERENCES = _.get(User.getWorkflowSettings(), [CURRENT_SCREEN], []);
    var componentData = _.find(USER_SCREEN_PREFERENCES, {
      name: component
    });
    return _.get(componentData, 'value');
  }
  function getUserSettingComponentByScreenName(component, screenName) {
    var User = userSecureService.getCurrentUser();
    var USER_SCREEN_PREFERENCES = _.get(User.getWorkflowSettings(), [screenName], []);
    var componentData = _.find(USER_SCREEN_PREFERENCES, {
      name: component
    });
    return _.get(componentData, 'value');
  }

  // TEMPORARY METHOD!
  // this method will replace getUserSettingComponent in near future
  // the main difference here is that getUserOrDefaultSettingComponent return user settings or
  // if they are not available get default workflow settings and return proper component value
  function getUserOrDefaultSettingComponent(component, fromWorkflow) {
    var userSetting = getUserSettingComponent(component, fromWorkflow);
    return _.isUndefined(userSetting) ? getDefaultSettingComponent(component, fromWorkflow) : userSetting;
  }
  function getDefaultSettingComponent(component, fromWorkflow) {
    return _.chain(configurationService.getDefaultWorkflowSettings()).get(fromWorkflow).find({
      name: component
    }).get('value').value();
  }
  function getUserDateTimeSettings(component) {
    var User = userSecureService.getCurrentUser();
    var userDateTimeSettings = User.getDateTimeSettings();
    var componentData = _.find(userDateTimeSettings, {
      name: component
    });
    var fallbackFormat = {
      dateFormat: MomentConstants.FORMATS.DATE,
      timeFormat: MomentConstants.FORMATS.TIME
    };
    return _.get(componentData, 'value') || fallbackFormat[component];
  }
  function getUserTimeZoneData() {
    return userSecureService.getUserTimeZoneData();
  }
  var dateFormats = {
    'DD/MM/YYYY': 'DD/MM',
    'MM/DD/YYYY': 'MM/DD',
    'DD-MMM-YY': 'DD-MMM'
  };
  function getShortDateUserSettings(dateFormat) {
    return dateFormats[dateFormat];
  }
  function extendMomentConstants() {
    var userDateFormat = getUserDateTimeSettings('dateFormat');
    var userTimeFormat = getUserDateTimeSettings('timeFormat');
    var shortDateSettings = getShortDateUserSettings(userDateFormat);
    _.extend(MomentConstants.FORMATS, {
      DATE_USER_SETTINGS: userDateFormat,
      TIME_USER_SETTINGS: userTimeFormat,
      DATE_TIME_USER_SETTINGS: userDateFormat + ' ' + userTimeFormat,
      SHORT_DATE_TIME_USER_SETTINGS: shortDateSettings + ' ' + userTimeFormat
    });
  }
  return {
    getUserTimeZoneData: getUserTimeZoneData,
    getUserSettingComponent: getUserSettingComponent,
    getUserSettingComponentByScreenName: getUserSettingComponentByScreenName,
    getUserOrDefaultSettingComponent: getUserOrDefaultSettingComponent,
    getUserDateTimeSettings: getUserDateTimeSettings,
    extendMomentConstants: extendMomentConstants
  };
};
UserPreferencesService.$inject = ['$state', 'UserSecureService', 'MomentConstants', 'ConfigurationService'];
module.exports = UserPreferencesService;